import { createSelector } from 'reselect'
import { IMountainPlayerData } from '../../../helpers/data/mountainPlayer'
import { IPlayerData } from '../../../helpers/data/player'
import { ICharacterData } from '../../../helpers/data/characterData'
import viewTypes from '../../../helpers/enums/views'
import hideStudentNamesSelector from '../app/hideStudentNamesSelector'
import hiddenNameText from '../../../helpers/enums/hiddenNameText'
import charactersSelector from '../app/charactersSelector'
import { IStore } from '../../reducers/index'
import skinSelector from '../app/skinSelector'

const playersSelector = (state: IStore) => {
	const players = state.game.participants
	const characters = charactersSelector(state)
	const shouldHideStudentNames = hideStudentNamesSelector(state)

	const campPlayers = players
		.filter((player: any) => player.view.type === viewTypes.GAME || player.view.type === viewTypes.WINNERS)
		.sort((a: IPlayerData, b: IPlayerData) => {
			return a.order - b.order
		})
		.map((player: any, index: number): IMountainPlayerData => {
			const characterData =
				characters.find((character: ICharacterData) => character.id === player.avatar) || characters[0]
			return {
				answered: player.view.type === viewTypes.GAME ? player.view.payload.isGameAnswered : '',
				answersUids: player.view.type === viewTypes.GAME ? player.view.payload.answersUids : '',
				avatarAsset: characterData.game,
				isAnswerCorrect: false,
				avatarIcon: characterData.loginIcon,
				avatarId: player.avatar,
				label: player.nickname,
				lane: index,
				nickname: shouldHideStudentNames ? hiddenNameText : player.nickname,
				playerUID: player.deviceUid,
				pos: player.view.type === viewTypes.GAME ? player.view.payload.pos : '',
				score: player.score,
			}
		})
		.sort((a: IMountainPlayerData, b: IMountainPlayerData) => {
			return b.score - a.score
		})
	return campPlayers
}

const activitiesSelector = (state: IStore) => {
	return state.game.activities
}

export default createSelector(
	activitiesSelector,
	playersSelector,
	skinSelector,
	(activities, players, skin) => {
		return {
			players,
			skin: skin.game,
			totalActivities: activities.length,
		}
	}
)
